import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Jumbotron from "../../components/Jumbotron/Jumbotron";
import { setIsActive } from "../../store/invoice/actions";
import PaidInvoice from "./Components/PaidInvoice";
import WaitingInvoice from "./Components/WaitingInvoice";
import "./Invoice.css";
import PendingInvoice from "./Components/PendingInvoice";

const links = [
  { name: "waiting", text: "Awaiting Payment" },
  { name: "pending", text: "Payment Pending" },
  { name: "paid", text: "Payment Complete" },
];

export default function Invoice() {
  const scroll = useRef(null);
  const dispatch = useDispatch();
  const savedActive = useSelector((state) => state.table.active);
  const [active, setActive] = useState(savedActive);

  useEffect(() => {
    scroll.current?.scrollIntoView();
  }, [active]);

  const handleActive = (name) => {
    setActive(name);
    dispatch(setIsActive(name));
  };

  const navigation = (
    <div className="mt-5 invoice-tabs" ref={scroll}>
      {links.map((link) => (
        <div
          key={link.name}
          className={`invoice-tab ${active === link.name ? "active" : ""}`}
          onClick={() => handleActive(link.name)}
        >
          <p className="invoice-tab-text">{link.text}</p>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <Jumbotron />
      {active === "waiting" ? (
        <WaitingInvoice navigation={navigation} />
      ) : active === "paid" ? (
        <PaidInvoice navigation={navigation} />
      ) : (
        <PendingInvoice navigation={navigation} />
      )}
    </>
  );
}
